import * as LandingRepository from 'repositories/landing';

import { reset } from 'redux-form';

import { FlashMessageActionCreators } from 'actions/flashMessage';
import { APPLICATION_FORM_NAME } from 'constants/app';
import { handleGenericApiError } from 'helper/error';
import { ActionCreator } from 'helper/redux';
import { LandingBusinessForm } from 'models/landing';
import { Thunk } from 'models/redux';

export const LandingActionCreators = {
  setIsOnRequest: new ActionCreator<'landing/SetIsOnRequest', void>('landing/SetIsOnRequest'),
  setIsReceived: new ActionCreator<'landing/SetIsReceived', void>('landing/SetIsReceived')
};

export function sendBusinessData(formValue: LandingBusinessForm): Thunk {
  return (dispatch) => {
    dispatch(LandingActionCreators.setIsOnRequest.create());
    return LandingRepository.sendBusinessData(formValue)
      .then(() => {
        dispatch(LandingActionCreators.setIsReceived.create());
        dispatch(FlashMessageActionCreators.show.create({
          modifier: 'success',
          text: 'action.success.landing.send.business.data'
        }));
        dispatch(reset(APPLICATION_FORM_NAME));
      })
      .catch((e) => {
        handleGenericApiError('action.failed.landing.send.business.data', e, dispatch);
        dispatch(LandingActionCreators.setIsReceived.create());
        console.error(e); // tslint:disable-line
      });
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/landing.ts